import { render, staticRenderFns } from "./ModalUserDelete.vue?vue&type=template&id=c85056b8&"
import script from "./ModalUserDelete.vue?vue&type=script&lang=js&"
export * from "./ModalUserDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports